import { reaction } from "mobx";

class CustomClipsStore {
  constructor(sportyApi) {
    this.sportyApi = sportyApi;
    this.clips = [];
    this.totalClips = 0;
    this.page = 0;
    this.clipsPerPage = 12;
    this.gamePk = "";
    this.description = "";
  }

  fetchClips(params) {
    throw new Error("Not Implemented");
  }

  initialize(options) {
    this.clipsPerPage = options.clipsPerPage || this.clipsPerPage;
    this.gamePk = options.gamePk || this.gamePk;
    this.description = options.description || this.description;

    reaction(
      () => this.clipsPerPage,
      () => {
        this.page = 0;
        this.refreshClips();
      }
    );

    reaction(
      () => this.description,
      () => {
        this.page = 0;
        this.refreshClips();
      }
    );

    reaction(
      () => this.gamePk,
      () => {
        this.page = 0;
        this.refreshClips();
      }
    );

    this.refreshClips();
  }

  refreshClips() {
    this.fetchClips({
      limit: this.clipsPerPage,
      page: this.page,
      gamePk: this._getGamePk(),
      description: this.description
    });
  }

  dispose() {
    this.clips = [];
    this.totalClips = 0;
    this.page = 0;
    this.clipsPerPage = 12;
    this.gamePk = "";
    this.description = "";
  }

  setPage(page) {
    this.page = page;

    // Only manually refresh clips when page is changed because changing other
    // filters also sets page to 0
    this.refreshClips();
  }

  setClipsPerPage(clipsPerPage) {
    this.clipsPerPage = clipsPerPage;
  }

  setDescription(description) {
    this.description = description;
  }

  setGamePk(gamePk) {
    if (!isNaN(gamePk)) {
      this.gamePk = gamePk;
    }
  }

  _getGamePk() {
    return this.gamePk === "" || isNaN(this.gamePk)
      ? null
      : parseInt(this.gamePk, 10);
  }
}

export default CustomClipsStore;



// WEBPACK FOOTER //
// ./src/stores/customClips/CustomClipsStore.js